var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: "images/anze-product.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [_vm._v("人保5至6类个人意外险（高空版）")]),
                  _c("div", { staticStyle: { color: "red" } }, [
                    _vm._v("5-6类职业 | 1人起保 | 可保高空"),
                  ]),
                  _c("p", [
                    _vm._v("\n\t\t\t\t\t① 5-6类职业，可保高空\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t② 最高可保50万\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t③ 1人起保，无需营业执照\n\t\t\t\t\t"),
                    _c("br"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                  _c("br"),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "25px" },
                      attrs: {
                        loading: _vm.isDownLoading,
                        icon: "el-icon-download",
                        size: "medium",
                        type: "text",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleDownLoad.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\t下载人保5至6类险职业类别表\n\t\t\t\t")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c("avue-crud", {
                    ref: "plan",
                    attrs: {
                      data: _vm.dataPlan,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (qa) {
                        return _c(
                          "li",
                          { key: qa.question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(qa.question))]
                              ),
                            ]),
                            _c("p"),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "background-color": "MediumSeaGreen",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c("span", {
                                staticStyle: { "white-space": "pre-wrap" },
                                domProps: { innerHTML: _vm._s(qa.answer) },
                              }),
                            ]),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c("h3", [_vm._v("一、产品基本信息")]),
                      _c(
                        "div",
                        { staticStyle: { "white-space": "pre-line" } },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t1、被保险人须符合如下要求: (1) 被保险人年龄范围 18 周岁（含）-65\n\t\t\t\t\t\t周岁（含），外籍人士及港澳台人士不支持投保； (2) 身体健康的，在中国大陆常住或生活的人员； (3)\n\t\t\t\t\t\t根据《中国人民财产保险股份有限公司意外伤害保险职业分类表》，被保险人职业类别限5-6类，其他职业不可投保。\n\t\t\t\t\t\t2、投保人须符合如下要求: (1)\n\t\t\t\t\t\t投保人应对被保险人具有可保利益，可以为被保险人本人或被保险人的父母、配偶、子女投保； (2)\n\t\t\t\t\t\t年龄18周岁的具有完全民事行为能力的自然人可作为投保人。 3、身故受益人：本产品受益人为法定受益人。\n\t\t\t\t\t\t4、本产品每人限购一份，多投无效。 5、保险期间：1年。 6、等待期：无等待期。\n\t\t\t\t\t\t7、生效日：本产品自投保之日起，最早\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("T+2日零时"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t生效。 8、赔付比例：\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t在保险期间内，被保险人遭受意外伤害事故，保险人就被保险人自事故发生之日起实际支出的按照当地(保单签发地)\n\t\t\t\t\t\t\t社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，每次免赔 100 元，剩余部分按\n\t\t\t\t\t\t\t80%赔付；未参加社会医疗保险身份就诊或结算的，对于事故发生之日起实际支出的按照当地(保单签发地)社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，每次免赔\n\t\t\t\t\t\t\t300 元，剩余部分按\n\t\t\t\t\t\t\t60%赔付；并且，保险期间届满被保险人治疗仍未结束的，保险人所负保险责任期限可按下列约定延长：门诊急诊治疗者，自保险期间届满次日起计算，以门诊急诊延长\n\t\t\t\t\t\t\t15 日为限；保险期间届满被保险人仍在住院治疗的，自保险期间届满次日起计算，至出院之日止，最长以 90\n\t\t\t\t\t\t\t日为限。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t9、本产品为一年期产品，不保证续保。 10、\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t退保规则：若投保人申请解除保险合同，保险人支持退保并退还本保险合同的现金价值，按下述公式计算现金价值：\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t现金价值=净保费×（1-m/n），其中，m为已生效天数，n为保险期间的天数，经过日期不足一日的按一日计算。\n\t\t\t\t\t\t"
                            ),
                          ]),
                        ]
                      ),
                      _c("span", { staticClass: "red-bold" }),
                      _c("el-divider"),
                      _c("h3", [_vm._v("二、保险机构信息")]),
                      _c(
                        "div",
                        { staticStyle: { "white-space": "pre-line" } },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t1、承保公司、销售主体：本产品由中国人民财产保险股份有限公司（简称中国人保财险）承保，目前中国人保财险在北京、上海、天津、重庆、河北、陕西、内蒙古、山西、辽宁、吉林、黑龙江、江苏、安徽、浙江、福建、江西、山东、湖北、湖南、河南、广东、广西、海南、四川、云南、贵州、甘肃、宁夏、青海、西藏、新疆、大连、青岛、宁波、厦门、杭州、广州、深圳设有分支机构。本产品由博维保险经纪有限公司广东分公司代理销售。\n\t\t\t\t\t\t2、销售范围：本产品的销售范围为全国。 3、条款适用：本产品适用条款为\n\t\t\t\t\t\t4、保单形式：网上投保为您提供电子保单，根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式，电子保单与纸质保单具有同等法律效力。你可以登录中国人保财险官网“http://www.epicc.com.cn”或关注“中国人保财险”微信公众号自助查询，对电子保单的真实性进行验证。\n\t\t\t\t\t\t5、发票形式：本产品仅提供电子发票，电子发票效力等同于纸质发票，报销可将电子发票打印后直接报销。\n\t\t\t\t\t\t6、如实告知：投保时，投保人应如实填写投保信息，并如实告知被保人的健康及职业状况。如未履行如实告知义务的，保险公司有权依法解除保险合同，并对合同解除前发生的保险事故不承担保险责任。\n\t\t\t\t\t\t7、客户授权：如您投保此保险，视为您本人授权中国人保财险和博维保险经纪有限公司广东分公司出于提升保险服务质量之目的，合法的从任何单位、组织和个人获取您本人有关的资料和证明，作为审核投保、处理理赔及提供与本保险有关其他服务的依据。\n\t\t\t\t\t\t8、信息安全：我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。\n\t\t\t\t\t\t9、公司偿付能力信息公开披露查询地址：\n\t\t\t\t\t\t"
                          ),
                          _c(
                            "el-link",
                            {
                              attrs: {
                                href: "https://www.picc.com/xwzx/gkxx/ndxx/",
                                type: "primary",
                              },
                            },
                            [_vm._v("公司偿付能力信息公开披露查询")]
                          ),
                          _vm._v(
                            "\n\t\t\t\t\t\t。 10、7*24小时服务热线/投诉热线：4006-366-366。\n\t\t\t\t\t"
                          ),
                        ],
                        1
                      ),
                      _c("h3", [_vm._v("三、特约约定")]),
                      _c(
                        "div",
                        { staticStyle: { "white-space": "pre-line" } },
                        [
                          _vm._v("\n\t\t\t\t\t\t1、每人\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("仅限投保一份，多投无效。"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t2、本保单被保险人年龄范围18周岁-65周岁，外籍人士及港澳台人士不支持投保。 3、\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t被保险人职业类别：本保单仅承保《中国人民财产保险股份有限公司意外伤害保险职业分类表》中5-6类职业人员，其他职业类别人员不在本保险合同的投保范围。被保险人职业类别以出险时的行为状态确定，从事不可保职业的人员为本保险不可保对象，本公司不承担保险责任；非不可保职业人员但从事不可保职业相关活动时发生的事故也不属于保险责任范围。其中下列职业被保险人不予投保：石材加工制造、矿业、采石业、炸药业、危险化工行业、直升机飞行人、飞行训练人、楼宇拆除工人爆破工作人员、潜水工作人员、火药、炸药制造人员、有关高压电工作人员、石棉瓦工作人员、特技演员、驯兽师、空中飞人、走钢丝人员、动物园驯兽师、保镖、炸药处理警察、防爆警察、警校学生、拳击运动员、各类赛车手、跳伞、登山运动人员、现役军人、煤矿业、油矿业。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t4、意外医疗费用补偿责任：\n\t\t\t\t\t\t（1）医院范围：本保单意外医疗相关保障指定就诊医院为中华人民共和国境内(不包括香港、澳门、台湾地区)\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("二级或二级以上公立医院"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t，且应符合下列所有条件:1)拥有合法经营执照；2)设立的主要目的为向受伤者和患病者提供留院治疗和护理服务；3)有合格的医生和护士提供全日二十四小时的医疗和护理服务；4)非主要作为康复医院、诊所、护理、疗养、戒酒、戒毒或类似的医疗机构。\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t但不包括以下医院：1）北京市的平谷区、密云区、怀柔区所有医院；2）江苏省的徐州市、南通市、连云港市所有医院；3）天津市的滨海、静海地区所有医院；4）辽宁省的铁岭市所有医院、辽宁中医药大学附属第二医院、中国人民解放军第二0五医院、辽宁省中医医院、营口市所有医院；5）吉林省的长春市、四平市所有医院、吉林省中医医院、吉林通化市人民医院、抚松县中医院；6）黑龙江省佳木斯市富锦市中心医院、中医医院、鸡西市所有医院；7）河北省的青县、青龙县、东光县、三河市、承德市兴隆县、廊坊市固安县所有医院、邯郸市馆陶县人民医院、南皮县中医医院；8）河南省的信阳市、洛阳市、郑州市、开封市、新乡市、商丘市、焦作市、安阳市黄县所有医院、通许县中医院；9）山东省的禹城市、栖霞市、莱州市、德州禹城、潍坊市高密县的所有医院、滨州市中心医院、青岛市即墨区中医医院、莱阳市中医医院、济宁市金乡县人民医院、鱼台县人民医院、荣成市中医院、烟台市中医院、富顺县中医院、曹县人民医院、济南市长清区人民医院；10）山西省运城市、阳泉市所有医院、太原市迎泽区中医院；11）四川省的宜宾市、内江市、雅安市所有医院、邛崃市医疗中心医院；12）内蒙古的扎兰屯市、赤峰市所有医院；13）广东省的湛江市第二中医医院、茂名市电白区人民医院；14）湖南省的衡阳市中医正骨医院、衡阳市中心医院；15）安徽省毫州市所有医院；16）甘肃省民勤县人民医院、庆阳市中医医院；17）福建南平的所有医院；18）所有私营社保定点医院。请注意：被保险人在上述医院进行治疗的保险人均不予以理赔，建议您去其他区域的\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v("二级或二级以上公立医院"),
                            ]),
                            _vm._v("\n\t\t\t\t\t\t\t就医。\n\t\t\t\t\t\t"),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t（2）赔付标准：\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t在保险期间内，对于被保险人遭受意外伤害之日起实际支出的当地(保单签发地)社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，在扣除社会基本医疗保险、公费医疗已经补偿或给付部分后，保险人按每次事故绝对免赔额100元，对其余额按80%比例给付；若被保险人未参加社会医疗保险身份就诊或结算的，对于事故发生之日起实际支出的按照当地(保单签发地)社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，保险人扣除每次事故绝对免赔额300元后，对其余额按60%比例给付。保险期间届满被保险人治疗仍未结束的，保险人所负保险责任期限可按下列约定延长：门诊急诊治疗者，自保险期间届满次日起计算，以门诊急诊延长15日为限；保险期间届满被保险人仍在住院治疗的，自保险期间届满次日起计算，至出院之日止，最长以90日为限。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t5、本产品意外伤害医疗保障，\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t不承担普通针刺治疗、针炙治疗、红外线治疗、可见光治疗、紫外线治疗、激光疗法、光敏疗法、直流电治疗、低频脉冲电治疗、中频脉冲电治疗、超短波短波治疗、微波治疗、射频电疗、静电治疗、空气负离子治疗、超声波治疗、电子生物反馈疗法、磁疗、水疗、蜡疗、泥疗、牵引、气压治疗、冷疗、电按摩、场效应治疗、中频脉冲电治疗、穴位贴敷治疗、中医定向透药疗法等中医治疗、理疗行为产生的医疗费用。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t6、意外住院津贴责任：意外住院津贴责任100元/天，\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "单次最高给付津贴日数30天，总给付日数180天，免赔天数0天。"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t7、在本保单可承保高空作业，\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t被保险人若从事高处作业【凡在坠落高度基准面2m以上(含2m)有可能坠落的高处进行的作业，高处作业以《高处作业分级标准》(中华人民共和国国家标准GB/T3608-2008)中的定义为准】，须按照相关行业安全管理规定取得由应急管理部门颁发《高处作业操作证》，否则发生死亡或伤残事故，保险人按照保单约定应承担保险责任的\n\t\t\t\t\t\t\t75%计算赔偿金额。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t8、被保险人\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t如系涉及特种行业岗位，根据《中华人民共和国安全生产法》之规定，必须持有国家安全生产监管局签发的特种作业操作证（不含高处作业操作证），或国家质量技术监督局签发的特种设备作业证上岗，否则本保险公司对可能发生的人身伤亡及医疗费用不承担赔偿责任。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t四、责任免除 *《中国人民财产保险股份有限公司意外伤害保险（互联网专属）条款》责任免除*\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t因下列情形之一，导致被保险人意外身故或意外伤残的，保险人不承担给付保险金的责任：\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t（1）投保人对被保险人的故意杀害、故意伤害；\n\t\t\t\t\t\t\t（2）被保险人故意自伤或自杀，但被保险人自杀时为无民事行为能力人的除外；\n\t\t\t\t\t\t\t（3）被保险人因挑衅或故意行为而导致的打斗、被袭击或被谋杀；\n\t\t\t\t\t\t\t（4）被保险人未遵医嘱服用、涂用、注射药物，但按使用说明的规定使用非处方药不在此限；\n\t\t\t\t\t\t\t（5）被保险人受酒精、毒品、管制药物的影响，但遵医嘱使用药物的情形不在此限；\n\t\t\t\t\t\t\t（6）疾病，包括但不限于高原反应、中暑、猝死； （7）非因意外伤害导致的细菌、病毒或其他病原体导致的感染；\n\t\t\t\t\t\t\t（8）过敏及由过敏引发的变态反应性疾病；\n\t\t\t\t\t\t\t（9）任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射；\n\t\t\t\t\t\t\t（10）战争、军事冲突、暴乱或武装叛乱、恐怖袭击； （11）被保险人故意犯罪或抗拒依法采取的刑事强制措施；\n\t\t\t\t\t\t\t（12）被保险人存在精神和行为障碍（以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类（ICD-10）》为准）；\n\t\t\t\t\t\t\t（13）被保险人接受包括美容、整容、整形手术在内的任何医疗行为而造成的意外；\n\t\t\t\t\t\t\t（14）被保险人妊娠、流产、分娩； （15）被保险人感染艾滋病病毒或患艾滋病（见释义）；\n\t\t\t\t\t\t\t（16）被保险人从事高风险运动（见释义），但被保险人作为专业运动员从事其专业运动不在此限；\n\t\t\t\t\t\t\t（17）被保险人酒后驾驶（见释义）、无合法有效驾驶证（见释义）驾驶或驾驶无合法有效行驶证（见释义）的机动交通工具。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\n\t\t\t\t\t\t*《中国人民财产保险股份有限公司附加意外伤害医疗保险A款（互联网专属）条款》责任免除*\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t1. 因下列情形之一，导致被保险人支出医疗费用的，保险人不承担给付保险金责任：\n\t\t\t\t\t\t\t（1）投保人对被保险人的故意杀害、故意伤害；\n\t\t\t\t\t\t\t（2）被保险人故意自伤或自杀，但被保险人自杀时为无民事行为能力人的除外；\n\t\t\t\t\t\t\t（3）被保险人因挑衅或故意行为而导致的打斗、被袭击或被谋杀； （4）被保险人妊娠、流产、分娩；\n\t\t\t\t\t\t\t（5）被保险人接受包括美容、整容、整形手术在内的任何医疗行为而造成的意外；\n\t\t\t\t\t\t\t（6）被保险人未遵医嘱服用、涂用、注射药物，但按使用说明的规定使用非处方药不在此限；\n\t\t\t\t\t\t\t（7）被保险人受酒精、毒品、管制药物的影响，但遵医嘱使用药物的情形不在此限；\n\t\t\t\t\t\t\t（8）任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射；\n\t\t\t\t\t\t\t（9）战争、军事冲突、暴乱或武装叛乱、恐怖袭击； （10）被保险人故意犯罪或抗拒依法采取的刑事强制措施；\n\t\t\t\t\t\t\t（11）被保险人存在精神和行为障碍（以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类（ICD-10）》为准）；\n\t\t\t\t\t\t\t（12）被保险人感染艾滋病病毒或患艾滋病（见释义）；\n\t\t\t\t\t\t\t（13）被保险人从事高风险运动（见释义），但被保险人作为专业运动员从事其专业运动不在此限；\n\t\t\t\t\t\t\t（14）被保险人酒后驾驶（见释义）、无有效驾驶证（见释义）驾驶或驾驶无有效行驶证（见释义）的机动交通工具；\n\t\t\t\t\t\t\t（15）疾病，包括但不限于高原反应、中暑、猝死（见释义）；\n\t\t\t\t\t\t\t（16）非因意外伤害导致的细菌、病毒或其他病原体感染； （17）过敏及由过敏引发的变态反应性疾病；\n\t\t\t\t\t\t\t（18）被保险人非因意外伤害而进行的整容、整形手术，以及因任何原因进行的美容；\n\t\t\t\t\t\t\t（19）被保险人非因意外伤害而进行的牙科治疗或手术、视力矫正、因矫正视力而作的眼科验光检查，以及任何原因导致的牙齿修复或牙齿整形、安装及购买残疾用具（如轮椅、假肢、假眼、假牙或者助听器等）；\n\t\t\t\t\t\t\t（20）被保险人进行一般身体检查、疗养、特别护理、静养、康复性治疗、物理治疗、心理治疗或预防性治疗；\n\t\t\t\t\t\t\t（21）被保险人在获得被保资格前已有残疾的治疗和康复； （22）被保险人在家自设病床治疗；\n\t\t\t\t\t\t\t（23）被保险人不符合入院标准住院、挂床住院（见释义）或应当出院但拒不出院而造成的延长住院。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "2. 对于本附加险合同载明的免赔额，保险人不承担给付保险金的责任。"
                            ),
                          ]),
                          _vm._v(
                            "\n\n\t\t\t\t\t\t*《中国人民财产保险股份有限公司附加意外伤害住院津贴保险A款（互联网专属）条款》责任免除*\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t1、因下列情形造成被保险人住院治疗的，保险人不承担给付保险金的责任： （1）\n\t\t\t\t\t\t\t投保人对被保险人的故意杀害、故意伤害； （2）\n\t\t\t\t\t\t\t被保险人故意自伤或自杀，但被保险人自杀时为无民事行为能力人的除外； （3）\n\t\t\t\t\t\t\t被保险人因挑衅或故意行为而导致的打斗、被袭击或被谋杀； （4）\n\t\t\t\t\t\t\t被保险人接受包括美容、整容、整形手术在内的任何医疗行为而造成的意外； （5）\n\t\t\t\t\t\t\t被保险人未遵医嘱服用、涂用、注射药物，但按使用说明的规定使用非处方药不在此限； （6）\n\t\t\t\t\t\t\t被保险人受酒精、毒品、管制药物的影响，但遵医嘱使用药物的情形不在此限； （7）\n\t\t\t\t\t\t\t任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射； （8）\n\t\t\t\t\t\t\t战争、军事冲突、暴乱或武装叛乱、恐怖袭击； （9） 被保险人故意犯罪或抗拒依法采取的刑事强制措施； （10）\n\t\t\t\t\t\t\t被保险人存在精神和行为障碍（以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类（ICD-10）》为准）；\n\t\t\t\t\t\t\t（11） 被保险人从事高风险运动（见释义），但被保险人作为专业运动员从事其专业运动不在此限； （12）\n\t\t\t\t\t\t\t被保险人酒后驾驶（见释义）、无合法有效驾驶证（见释义）驾驶或驾驶无合法有效行驶证（见释义）的机动交通工具；\n\t\t\t\t\t\t\t（13） 疾病，包括但不限于高原反应、中暑、猝死（见释义）； （14）\n\t\t\t\t\t\t\t非因意外伤害导致的细菌、病毒或其他病原体导致的感染； （15） 过敏及由过敏引发的变态反应性疾病； （16）\n\t\t\t\t\t\t\t被保险人非因意外伤害而进行的整容、整形手术，以及因任何原因进行的美容； （17）\n\t\t\t\t\t\t\t被保险人非因意外伤害而进行的牙科治疗或手术、视力矫正、因矫正视力而作的眼科验光检查，以及任何原因导致的牙齿修复或牙齿整形、安装及购买残疾用具（如轮椅、假肢、假眼、假牙或者助听器等）；\n\t\t\t\t\t\t\t（18） 被保险人进行一般身体检查、疗养、特别护理、静养、康复性治疗、物理治疗、心理治疗或预防性治疗；\n\t\t\t\t\t\t\t（19） 被保险人妊娠、流产、分娩； （20） 被保险人在投保前已有残疾的治疗和康复。\n\t\t\t\t\t\t\t2、对于以下情形，保险人也不承担给付保险金的责任： （1）\n\t\t\t\t\t\t\t被保险人在家自设病床治疗，或在门诊观察室、急诊观察室、其他非正式病房、联合病房的治疗； （2）\n\t\t\t\t\t\t\t被保险人不符合入院标准住院、挂床住院（见释义）或住院病人应当出院但拒不出院而造成的延长的住院日数。\n\t\t\t\t\t\t\t3、对于按本附加险合同载明的免赔日数计算出的免赔金额，保险人不承担赔偿责任。\n\t\t\t\t\t\t"
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }